import { IProcessedStyleSet, ITheme, mergeStyleSets } from '@fluentui/react'
import { flow } from 'lodash/fp'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getTheme } from '../../store/ui/selectors'
type ObjectOnly<TArg> = TArg extends object ? TArg : object
export const useClasses = <TStyleSet>(
  getThemedStyleSet: (theme: ITheme) => TStyleSet
): IProcessedStyleSet<ObjectOnly<TStyleSet>> => {
  const theme = useSelector(getTheme)
  return useMemo(
    () => flow(getThemedStyleSet, mergeStyleSets)(theme),
    [theme, getThemedStyleSet]
  )
}
